/* eslint react-hooks/static-components: ["warn"] */
import styled, { css } from "styled-components";
import Arrows_Chevron_Medium_Right from "../assets/svg/arrow-small-forward.svg?react";
import Actions_Delete from "../assets/svg/actions-delete-default.svg?react";
import Actions_Torch_On from "../assets/svg/actions-torch-on.svg?react";
import Actions_Torch_Off from "../assets/svg/actions-torch-off.svg?react";
import Actions_Refresh from "../assets/svg/refresh.svg?react";
import Actions_Close_Small from "../assets/svg/close-small.svg?react";
import Actions_Close_Large from "../assets/svg/close-large.svg?react";
import Slash from "../assets/svg/slash.svg?react";
import Repeatable from "../assets/svg/recurring.svg?react";
import Comment from "../assets/svg/comment.svg?react";
import Check from "../assets/svg/check.svg?react";
import LinkOut from "../assets/svg/link-out.svg?react";
import StateOngoing from "../assets/svg/state_ongoing.svg?react";
import StateAccepted from "../assets/svg/state_accepted.svg?react";
import StateRejected from "../assets/svg/state_declined.svg?react";
import Wrench from "../assets/svg/wrench.svg?react";
import Pencil from "../assets/svg/pencil.svg?react";
import MagnifyingGlass from "../assets/svg/magnifying_glass.svg?react";
import Calendar from "../assets/svg/calendar.svg?react";
import Truck from "../assets/svg/truck.svg?react";
import Download from "../assets/svg/arrow_down_to_base.svg?react";
import Globe from "../assets/svg/globe.svg?react";
import Camera from "../assets/svg/camera.svg?react";
import RectangleHorizontal from "../assets/svg/rectangle-horizontal.svg?react";
import RectangleHorizontalDouble from "../assets/svg/rectangle-horizontal-double.svg?react";
import ExclamationSign from "@coworker/reusable/svg/priority-exclamation-sign.svg?react";
import Description from "../assets/svg/comment.svg?react";
import Merge from "../assets/svg/icon-arrow-merge.svg?react";
import Location from "../assets/svg/location.svg?react";
import Sofa from "../assets/svg/sofa.svg?react";
import Flag from "../assets/svg/flag.svg?react";
import Amount from "../assets/svg/amount-icon.svg?react";

const Wrapper = styled("div")`
  width: ${({ size }) => `${size}px`};
  ${(props) =>
    props.className === "removeHeight"
      ? ""
      : css`
          height: ${props.size}px;
        `}
  color: var(${({ color }) => `--${color}`});
  display: inline-block;
  & > svg {
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    max-width: 100%;
    max-height: 100%;
  }
`;

const library = {
  arrows: {
    "chevron-right": Arrows_Chevron_Medium_Right,
    slash: Slash,
  },
  actions: {
    delete: Actions_Delete,
    "torch-on": Actions_Torch_On,
    "torch-off": Actions_Torch_Off,
    refresh: Actions_Refresh,
    "close-small": Actions_Close_Small,
    "close-large": Actions_Close_Large,
    recurring: Repeatable,
  },
  icons: {
    comment: Comment,
    check: Check,
    linkOut: LinkOut,
    state_accepted: StateAccepted,
    state_declined: StateRejected,
    state_ongoing: StateOngoing,
    wrench: Wrench,
    pencil: Pencil,
    magnifying_glass: MagnifyingGlass,
    truck: Truck,
    calendar: Calendar,
    download: Download,
    globe: Globe,
    camera: Camera,
    rectangle_horizontal: RectangleHorizontal,
    rectangle_horizontal_double: RectangleHorizontalDouble,
    warning_triangle: ExclamationSign,
    description: Description,
    merge: Merge,
    location: Location,
    sofa: Sofa,
    flag: Flag,
    amount: Amount,
  },
};

/**
 * @param {{family:string,name:string,mode?:string,color?:string,size?:number,className?:string}} param0
 */
export default function Icon({
  family,
  name,
  color = "black",
  size = 16,
  className,
}) {
  const Icon = library[family]?.[name] || (() => "(icon)");
  return (
    <Wrapper color={color} className={className} size={size}>
      <Icon width={size} height={size} />
    </Wrapper>
  );
}
